/**
 * PromoBanner — running ticker that sits above the Navbar.
 * ~36px tall. Scrolls left continuously.
 * Phrases are loaded from GET /api/site-info (promo_phrases field).
 * Falls back to hardcoded phrases if the API returns none.
 */
import { useState, useEffect } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const FALLBACK_PROMOS = [
  "🏦 Your machine earns while you sleep — place it once, collect forever",
  "🎮 Arcade machines, claw units & token dispensers — all in stock now",
  "🛡️ Every unit ships with a 12-month manufacturer warranty — you're covered",
  "📦 MOQ of 1 — no bulk commitment, no minimums, just order and go",
  "💳 Cashless-ready — Visa, Mastercard, Apple Pay & Google Pay accepted",
  "🌎 Shipping to 40+ countries — your operation starts wherever you are",
  "🕹️ Combo, snack, refrigerated & arcade — the full lineup is live",
];

export default function PromoBanner() {
  const [phrases, setPhrases] = useState(FALLBACK_PROMOS);

  useEffect(() => {
    fetch(`${API}/site-info`)
      .then(r => r.json())
      .then(d => {
        if (Array.isArray(d.promo_phrases) && d.promo_phrases.length > 0) {
          setPhrases(d.promo_phrases);
        }
      })
      .catch(() => { /* keep fallback */ });
  }, []);

  // Duplicate for seamless loop
  const items = [...phrases, ...phrases];

  return (
    <div
      style={{
        height: 36,
        background: "var(--grad-primary)",
        overflow: "hidden",
        position: "relative",
        zIndex: 101,
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 0,
          animation: "ticker-scroll 40s linear infinite",
          whiteSpace: "nowrap",
          willChange: "transform",
        }}
      >
        {items.map((text, i) => (
          <span
            key={i}
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 12,
              fontWeight: 500,
              color: "rgba(255,255,255,0.92)",
              letterSpacing: "0.02em",
              padding: "0 40px",
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            {text}
            <span style={{ opacity: 0.35, fontSize: 8 }}>●</span>
          </span>
        ))}
      </div>

      <style>{`
        @keyframes ticker-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
